import styled from "@emotion/styled";

export const GradientTop = styled.div(({theme}) => ({
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  zIndex: 2,
  background:
    "linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.4) 51.56%, rgba(0, 0, 0, 0) 100%, rgba(0, 0, 0, 0) 100%)",
  width: "100%",
  height: theme?.breakpoints?.isMobile ? 88 : 96,
}));

export const TextContainer = styled.div(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  gridColumn: theme?.breakpoints?.isMobile ? "1/-1" : "3/15",
  width: "100%",
  marginBlock: theme?.breakpoints?.isMobile ? 30 : 40,
}));

export const TextWrapper = styled.div(({isTextExpanded}) => ({
  // opacity: isTextExpanded ? 1 : 0,
  // height: isTextExpanded ? "100%" : "0px",
  overflow: "hidden",
  // transition: "all 0.5s ease",
}));

export const ToggleTextLength = styled.div(({theme}) => ({
  width: "fit-content",
  marginTop: 10,
  fontSize: "1rem",
  lineHeight: 1.5,
  fontWeight: 700,
  fontFamily: theme?.font?.manrope,
  textDecoration: "underline",
  transition: "color 0.3s",
  cursor: "pointer",
  ":hover": {
    color: "#27509b",
  },
}));

export const ScrollToNextSection = styled.div(({theme}) => ({
  position: "absolute",
  left: "calc(50% - 12px)",
  bottom: theme?.breakpoints?.isMobile ? 50 : 20,
  width: 25,
  height: 40,
  cursor: "pointer",
}));

export const LogoWrapper = styled.div(({theme}) => ({
  bottom: theme?.breakpoints?.isMobile ? 40 : 64,
  right: theme?.breakpoints?.isMobile ? 10 : 64,
  position: "absolute",
  marginTop: "auto",
  color: "rgba(255, 255, 255, 0.8)",
  display: "flex",
  flexDirection: "column",
}));

export const Logo = styled.div(({imgUrl, theme}) => ({
  height: theme?.breakpoints?.isMobile ? 80 : 120,
  width: theme?.breakpoints?.isMobile ? 160 : 240,
  backgroundImage: `url("${imgUrl}")`,
  backgroundSize: "contain",
  backgroundPosition: "right",
  backgroundRepeat: "no-repeat",
}));
